import { cn } from "@/lib/utils";
import { useState } from "react";

/**
 * Helper component for truncated text with read more
 * @param text - The text to be truncated
 * @returns A component that displays the text and a button to expand it
 */
export const ExpandableText = ({ text }: { text: string }) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleExpanded = () => {
		setIsExpanded((prev) => !prev);
	};

	// Check if text needs truncation (rough estimation based on character count)
	const needsTruncation = text.length > 200;

	if (!needsTruncation) {
		return <p className="text-sm text-gray-700 mt-2 leading-relaxed">{text}</p>;
	}

	return (
		<div className="mt-2">
			<p
				className={cn(
					"text-sm text-gray-700 leading-relaxed",
					!isExpanded ? "line-clamp-2" : "line-clamp-none"
				)}
			>
				{text}
			</p>
			<div className="flex justify-end">
				<button
					onClick={toggleExpanded}
					className="text-sm text-prussian-blue-500 hover:text-prussian-blue-400 mt-1"
				>
					{isExpanded ? "Read less" : "Read more"}
				</button>
			</div>
		</div>
	);
};
